import { Team } from '@/types';

// Helper function to format player names as "LastName Initial."
export const formatPlayerName = (fullName: string): string => {
  const nameParts = fullName.trim().split(/\s+/);

  if (nameParts.length === 0) return '';

  if (nameParts.length === 1) {
    // If there's only one name, return it as is
    return nameParts[0];
  }

  // Take the last element as the last name and the first as the first name
  const firstName = nameParts[0];
  const lastName = nameParts[nameParts.length - 1];

  // Format: "LastName Initial."
  return `${lastName} ${firstName.charAt(0).toUpperCase()}.`;
};

// Function to get the team's name
export const getTeamName = (team: Team | undefined | null): string => {
  // If there's no team or it has no players, return a default value
  if (!team || !team.players || !team.players.length) return 'Unknown team';

  // Return the names of the players with the new format
  return team.players
    .map((player) => {
      if (player && player.name) {
        return formatPlayerName(player.name);
      }
      return '';
    })
    .filter(Boolean)
    .join(' / ');
};
